// NOTE: 该页面是entry-h5页面的初始化应用的真正承载功能
import Vue from 'vue'
import App from './App.vue'
import router from '@/router/index.js'
import store from '@/store/index.js'
import { i18n, setBDLocale, setBDCountry, setBDTimezone, getBDLocale } from '@/common/utils/i18n.js'

import { urlParse, replyPathChangeIsRefersh } from '@/common/utils/util.js'
import { trackEvent } from '@/common/utils/log.js'
import { cloneDeep } from 'lodash-es'
import Locale from '@didi/rich-ui/lib/locale'
import SodaMasMonitor from '@didi/soda-mas-monitor'

import storage from 'didi-store'
import vueI18n from '@/i18n/locale.js'
import Message from '@didi/gattaran-plugin-message-center'
import env from '@/common/utils/getEnv.js'
import { isPre, isSim, isLocal } from '@/common/utils/env'
import { init, setTimezone } from '@didi/elvish-lib-javascript'
import { initRaven } from './raven'
import dayjs from 'dayjs'
import 'dayjs/locale/en' // ES 2015
import 'dayjs/locale/zh-cn' // ES 2015
import 'dayjs/locale/pt-br' // ES 2015
import 'dayjs/locale/es-mx' // ES 2015
import 'dayjs/locale/ja'
import { initBridgeReport } from './bridge-report.js' // ES 2015
import { initPerformanceTool } from './performance-tool.js' // ES 2015
import { initVue } from './vue-instance'
import { isAbasteceBiz } from './common/utils/BizUtils'
import { GlobalUserInfoLocalStorageKey } from './common/utils/constant'

const dayjsLocale = {
  'en-US': 'en',
  'zh-CN': 'zh-cn',
  'pt-BR': 'pt-br',
  'es-MX': 'es-mx',
  'ja-JP': 'ja',
  'es-CR': 'es-mx',
  'es-CO': 'es-mx',
}

const localLocale = getBDLocale()
dayjs.locale(dayjsLocale[localLocale])

const isPro = process.env.NODE_ENV === 'production'
// 判断环境
const envMap = {
  development: 'dev',
  dev: 'dev',
  production: 'pro',
  pro: 'pro',
  pre: 'pre',
  sim: 'dev',
  mock: 'mock',
}

const getEnv = config => {
  if (isPre) {
    return 'pre'
  }
  if (isSim || isLocal) {
    return 'dev'
  }
  return envMap[config.apiEnv || 'pro']
}

export async function initEntryH5DataSet(res) {
  if (res.data && res.errno === 0) {
    storage.set(GlobalUserInfoLocalStorageKey, res)
    if (res.data.locale && localLocale !== res.data.locale) {
      setBDLocale(res.data.locale)
      window.location.reload()
    } else {
      return res.data
    }
  }
}

let vueInstance = null

// 重新运行白屏监听事件
function whiteScreenMonitorChange() {
  try {
    if (window.Omega) {
      // 屏蔽掉localhost、sim环境的白屏监控
      window.Omega.setConfig(
        isPro && !isSim && !isLocal
          ? {
              appKey: 'omega8a8b1d642d',
              autoError: true,
              // 白屏监控问题，需要传入全量配置
              autoWhiteScreenMonitor: {
                container: '#app',
                checkDisplayNone: true, // 去除 display:none 的元素
                childrenDepth: 4,
                durationSeconds: 10000,
                observerRange: 3,
              },
            }
          : {
              autoError: false, // 过滤掉测试环境js错误上报到bdapp omega应用组
            },
      )

      window.$mounted && window.$mounted()
    }
  } catch (err) {
    console.error(err)
  }
}

export function initEntryH5VueInstance(data, messageMap) {
  const query = urlParse(location.href)
  const loginData = {
    ticket: query.ticket || storage.get('ticket'),
    uname: query.u || storage.get('uname'),
  }
  //  线上报错 Uncaught (in promise) undefined is not an object (evaluating 't.country')，已解决
  const country = data.country || (isAbasteceBiz(data.bizId) ? 'BR' : 'MX')
  const _router = router(country)
  _router.beforeEach(async (to, from, next) => {
    // 每次切换路由的时候重新给标识记录新值
    storage.set('changeRouterTimeStamp', +new Date())
    storage.set('frontPath', to.fullPath || '')
    const routerQueue = store.state.routerQueue
    const cloneRouterQueue = cloneDeep(routerQueue)
    if (to.meta.requiresAuth === false) {
      // 免登录逻辑
      next()
    }
    if (to.name === 'home') {
      // 要去的页面是门店列表，并且是从商机详情或者商家详情跳过来的，则不刷新门店列表
      replyPathChangeIsRefersh({
        toObj: to,
        routerQueue: cloneRouterQueue,
        toPath: '/home/list',
        fromName: ['shopDetail', 'bizoppDetail'],
        mutationMethod: 'updateIsRefreshHomeList',
        store,
      })
      // 要去的页面是任务列表，并且是从任务详情跳过来的，则不刷新任务列表
      replyPathChangeIsRefersh({
        toObj: to,
        routerQueue: cloneRouterQueue,
        toPath: '/home/summary',
        fromName: ['TaskName'],
        mutationMethod: 'updateIsRefreshTaskList',
        store,
      })
      store.commit('updateRouterQueue', [])
    } else {
      cloneRouterQueue.push(to.name)
      store.commit('updateRouterQueue', cloneRouterQueue)
    }
    next()
  })
  _router.afterEach((to, from) => {
    if (window.Omega && isPro) {
      setTimeout(() => {
        window.Omega.sendPageView && window.Omega.sendPageView()
        trackEvent('sailing_gattarman_x_page_leave', {
          pageName: from.name,
        })
        trackEvent('sailing_gattarman_x_page_entry', {
          pageName: to.name,
        })
      })
    }
  })
  setBDLocale(data.locale)
  setBDCountry(data.country)
  setBDTimezone(data.timezone)
  // init i18n
  Vue.use(i18n.plugin)
  // set rich-ui locale
  Locale.use(localLocale, messageMap[localLocale])
  storage.set('changeRouterTimeStamp', +new Date())
  store.dispatch('updateLoginData', Object.assign(loginData, { userInfo: data }))
  // 初始化消息中心
  const config = env.get('config')
  Vue.prototype.MessageCenter = new Message(
    {
      country: data.country,
      locale: data.locale,
      msgChannel: 2,
      signature: '',
      timestamp: '',
      // msgType: MSG_TYPE_KEY,
      timezone: data.timezone,
      uid: data.username,
      ticket: query.ticket || storage.get('ticket'),
      referer: window.location.href,
    },
    {
      apiEnv: getEnv(config),
      // apiEnv: 'pro',
      // baseHttpHost: 'https://sim275.rlab.sim.intra.xiaojukeji.com/dilu/gateway', // 设置该项后，apiEnv不生效
      pollingTime: 10 * 800,
      // 模拟接口
      apiMapRelation: {
        // 'spacex.msg.message.list': 'https://mock.xiaojukeji.com/mock/11225/sada/wby/messageList',
        // 'spacex.msg.message.isNewV2': 'https://mock.xiaojukeji.com/mock/11225/sada/wby/isNew',
      },
    },
  )
  console.log('当前环境是：', getEnv(config))
  // eslint-disable-next-line no-new
  if (!vueInstance) {
    // elvish的初始化
    const realLocale = `${data.locale.split('-')[0]}_${data.country}`
    init(realLocale, data.country).then(() => {
      // eslint-disable-next-line no-new
      new SodaMasMonitor({
        env: process.env.NODE_ENV,
        Omega: window.Omega,
        openTestTrack: false,
      })
      setTimezone(data.timezone)
      vueInstance = initVue({
        el: '#app',
        i18n: vueI18n,
        store,
        router: _router,
        mounted() {
          // 在应用挂载完成后触发自定义事件
          window.dispatchEvent(new CustomEvent('soda-mas-monitor-app-mounted'))
        },
        template: '<App/>',
        components: { App },
      })
    })
    // 初始化桥接埋点
    initBridgeReport()
    // 初始化天眼
    initRaven(data.username || data.uid)
    // 初始化性能收集
    initPerformanceTool(_router)
    // 白屏需要重新运行，omega白屏监控的bug
    whiteScreenMonitorChange()
  }
}

export function updateLocalStorage(locale, country, timezone) {
  const LocalUserInfo = storage.get(GlobalUserInfoLocalStorageKey)
  if (LocalUserInfo) {
    LocalUserInfo.data.locale = locale
    LocalUserInfo.data.country = country
    LocalUserInfo.data.timezone = timezone
    storage.set(GlobalUserInfoLocalStorageKey, LocalUserInfo)
  }
}

// phase: 1: 首次页面加载 2: getUserInfo请求 3: login页面到回到bdapp的时间 4: 回到bdapp的页面加载时间 5: 回到bdappgetUserInfo请求时间
export function trackLoginProcessByPhase(phase = 0, duration = 0, attrs = {}) {
  trackEvent('sailing_gattarman_x_unlogin_to_login_time_sw', {
    phase,
    time_diff: duration,
    ...attrs,
  })
}

export function getLastNotLoginTimestamp() {
  return storage.get('notLoginToRedirect')
}
